// extracted by mini-css-extract-plugin
module.exports = {"CustomCard":"styles_CustomCard__c52-1"};